import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import ICountry from '../../interfaces/ICountry'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { countryList } from '../../services/api'

interface CountryState extends BaseContextState {
  countries: Array<ICountry> | null
}

export interface CountryData extends CountryState {
  resetErrors: Function,
  requestCountryList: (args: SearchRequest) => void,
}

// Create context
const { Provider, Consumer } = createContext({} as CountryData)

// Export consumer
export const CountryConsumer = Consumer

export class CountryProvider extends BaseContextProvider {
  state: CountryState = {
    countries: null,
  }

  lastListPayload: SearchRequest | null = null

  /**
   * Make api request for country list
   * 
   * @param {SearchRequest} payload 
   */
  requestCountryList = (payload: SearchRequest) => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      this.lastListPayload = payload
      const response = await countryList(payload)

      // Process our response
      this.processResponse(response, { 
        paginate: {
          destination: 'countries'
        },
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestCountryList: this.requestCountryList
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
